export default __webpack_public_path__ + "static/media/support-notes-main-clarin.4f270f3c.png";